<ng-container *ngIf="event$ | async as event">
  <div class="page-header">
    <h1 class="ml-2">Encoder</h1>
  </div>
  <div class="encoders">
    <div
      *ngFor="let transcoder of encoders | async; let i = index"
      [formGroup]="transcoder.formGroup"
      class="encoder item"
    >
      <app-dropdown
        [options]="userAddedEncoders"
        [valuePrimitive]="true"
        label="Encoder"
        formControlName="encoderId"
        class="encoder"
      ></app-dropdown>

      <app-dropdown
        [options]="languagesDropdown"
        [valuePrimitive]="true"
        label="Language"
        class="language"
        formControlName="language"
      >
      </app-dropdown>

      <app-dropdown
        [options]="encoderStatusDropdown"
        [valuePrimitive]="true"
        label="Output"
        class="enabled"
        formControlName="enabled"
      >
      </app-dropdown>

      <div class="preview">
        <label>Live Preview</label>
        <p *ngIf="transcoder.livePreview$ | async as preview">{{ preview }}</p>

        <button
          class="btn btn-link delete-button"
          (click)="removeTranscoder(transcoder.uuid)"
        >
          <i class="fas fa-trash"></i> Remove
        </button>
      </div>
    </div>

    <button
      (click)="addTranscoder()"
      class="btn btn-link pl-0 add-encoder item"
    >
      <i class="fas fa-plus"></i> New
    </button>
  </div>
</ng-container>
